export default __webpack_public_path__ + "static/media/i-metamask.b082c008.svg";